// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
    width: 3px; 
  }
  
  /* Define the styles for the scrollbar thumb */
  ::-webkit-scrollbar-thumb {
    background-color: rgb(94, 64, 242);; /* Set the color of the thumb */
    border-radius: 6px; /* Round the corners of the thumb */
  }
  
  /* Define the styles for the scrollbar track */
  ::-webkit-scrollbar-track {
    background-color: rgb(94, 64, 242);
    display:none /* Set the color of the track */
  }
  
  ::-webkit-scrollbar-corner {
    background-color: #c9cacc; /* Set the color of the corner */
  }
  .MuiAutocomplete-inputRoot{
    padding-right:8px !important;

    }

    .select-text{
      padding: 7px;
    }
.MuiOutlinedInput-root{
  border-radius: 0px;
  /* background-color: rgb(244, 246, 248); */
}
.status-select,.tag-select,.location-select,.violation-select{
  background-color: rgb(244, 246, 248);
  border: 0px !important;
}

  /* .MuiOutlinedInput-notchedOutline {
    border: none ! important ;
  } */
  .MuiAutocomplete-inputRoot{

  }


  #status.MuiAutocomplete-inputFocused{
    /* color:rgb(86, 86, 243); */
  }
  .contract-search-icon{
    /* margin-left:25px; */
    /* padding-left:20px; */

  }
  .MuiSelect-iconOutlined {
    color: red; /* Change to your desired color */
  }
  .report-dropdown-arrow-icon{
    transition: transform 0.3s ease;
    margin-right: 10px;
    transform:rotate(0deg);
    color:rgba(0, 0, 0, 0.87);
  }
  .report-status-dropdown-arrow-selected,.report-tag-dropdown-arrow-selected,.report-location-dropdown-arrow-selected,.report-violation-dropdown-arrow-selected{
    color:rgb(64, 64, 242);
    transform: rotate(180deg);
    fill: rgb(64, 64, 242);
  }

  .report-status-dropdown-selected,.report-tag-dropdown-selected,.report-location-dropdown-selected,.report-violation-dropdown-selected{
    background-color: rgb(236, 236, 254);
    color:rgb(86, 86, 244) !important;
  }
  .cls-1 {
    stroke-width: 0px;
  }
  .report-refresh-icon:hover{
    cursor:pointer;
  }`, "",{"version":3,"sources":["webpack://./src/pages/report/report.css"],"names":[],"mappings":"AAAA;IACI,UAAU;EACZ;;EAEA,8CAA8C;EAC9C;IACE,kCAAkC,GAAG,+BAA+B;IACpE,kBAAkB,EAAE,mCAAmC;EACzD;;EAEA,8CAA8C;EAC9C;IACE,kCAAkC;IAClC,WAAW,EAAE,+BAA+B;EAC9C;;EAEA;IACE,yBAAyB,EAAE,gCAAgC;EAC7D;EACA;IACE,4BAA4B;;IAE5B;;IAEA;MACE,YAAY;IACd;AACJ;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;EAEE;;KAEG;EACH;;EAEA;;;EAGA;IACE,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,uBAAuB;;EAEzB;EACA;IACE,UAAU,EAAE,iCAAiC;EAC/C;EACA;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,iCAAiC;EACnC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB","sourcesContent":["::-webkit-scrollbar {\r\n    width: 3px; \r\n  }\r\n  \r\n  /* Define the styles for the scrollbar thumb */\r\n  ::-webkit-scrollbar-thumb {\r\n    background-color: rgb(94, 64, 242);; /* Set the color of the thumb */\r\n    border-radius: 6px; /* Round the corners of the thumb */\r\n  }\r\n  \r\n  /* Define the styles for the scrollbar track */\r\n  ::-webkit-scrollbar-track {\r\n    background-color: rgb(94, 64, 242);\r\n    display:none /* Set the color of the track */\r\n  }\r\n  \r\n  ::-webkit-scrollbar-corner {\r\n    background-color: #c9cacc; /* Set the color of the corner */\r\n  }\r\n  .MuiAutocomplete-inputRoot{\r\n    padding-right:8px !important;\r\n\r\n    }\r\n\r\n    .select-text{\r\n      padding: 7px;\r\n    }\r\n.MuiOutlinedInput-root{\r\n  border-radius: 0px;\r\n  /* background-color: rgb(244, 246, 248); */\r\n}\r\n.status-select,.tag-select,.location-select,.violation-select{\r\n  background-color: rgb(244, 246, 248);\r\n  border: 0px !important;\r\n}\r\n\r\n  /* .MuiOutlinedInput-notchedOutline {\r\n    border: none ! important ;\r\n  } */\r\n  .MuiAutocomplete-inputRoot{\r\n\r\n  }\r\n\r\n\r\n  #status.MuiAutocomplete-inputFocused{\r\n    /* color:rgb(86, 86, 243); */\r\n  }\r\n  .contract-search-icon{\r\n    /* margin-left:25px; */\r\n    /* padding-left:20px; */\r\n\r\n  }\r\n  .MuiSelect-iconOutlined {\r\n    color: red; /* Change to your desired color */\r\n  }\r\n  .report-dropdown-arrow-icon{\r\n    transition: transform 0.3s ease;\r\n    margin-right: 10px;\r\n    transform:rotate(0deg);\r\n    color:rgba(0, 0, 0, 0.87);\r\n  }\r\n  .report-status-dropdown-arrow-selected,.report-tag-dropdown-arrow-selected,.report-location-dropdown-arrow-selected,.report-violation-dropdown-arrow-selected{\r\n    color:rgb(64, 64, 242);\r\n    transform: rotate(180deg);\r\n    fill: rgb(64, 64, 242);\r\n  }\r\n\r\n  .report-status-dropdown-selected,.report-tag-dropdown-selected,.report-location-dropdown-selected,.report-violation-dropdown-selected{\r\n    background-color: rgb(236, 236, 254);\r\n    color:rgb(86, 86, 244) !important;\r\n  }\r\n  .cls-1 {\r\n    stroke-width: 0px;\r\n  }\r\n  .report-refresh-icon:hover{\r\n    cursor:pointer;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
